import axios from 'axios';
import { API_BASE_URL } from '../constants';

export default class TaskManagerService {
	static instance;

	static getInstance() {
		if (!TaskManagerService.instance) {
			TaskManagerService.instance = new TaskManagerService();
		}

		return TaskManagerService.instance;
	}

    async fetchTasks(assetId, params = {}){
        const response = await axios.post(`${API_BASE_URL}/software/${assetId}/tasks`, params, {
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });
        return response.data.data
    }

    async fetchOwners(assetId, payload = {}){
        const response = await axios.post(`${API_BASE_URL}/analystAndAdminAnalystAndTaskOwners.list`, payload, {
            params: {},
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`,
            },
        });
  
        return response.data.data;
    }

    async fetchCategories(assetId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/task/categories`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            },
        });

        return response.data?.data || [];
    }

    async deleteTask(assetId, taskId){
        const response = await axios.delete(`${API_BASE_URL}/task/${taskId}/delete`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                }
            }
        );
  
        return response.data.data;
    }    

    async fetchRecurringTaskChildren(taskId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/tasks/${taskId}/recurring-tasks`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });
        return response.data.data
    }

    async fetchMitigationCategories(supplierId, params = {}){
        const response = await axios.get(`${API_BASE_URL}/mitigation-task/categories`, {
            params  :   params,
            headers :   {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data?.data || [];
    }
}